import { render, staticRenderFns } from "./LoginBranding.vue?vue&type=template&id=f95d0bf8&"
import script from "./LoginBranding.vue?vue&type=script&lang=js&"
export * from "./LoginBranding.vue?vue&type=script&lang=js&"
import style0 from "./LoginBranding.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports